import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'


const config = {
  types: [
    {
      title: 'top',
      isDefault: true
    },
    'right',
    'bottom',
    'left'
  ],
  modifiers: [],
  states: []
}

export default function Tooltip(props) {
  const { isVisible, children, top, left, right, bottom, ...rest } = props
  // const _props = clearProps(props)
  return (
    <div
      {...rest}
      className={resolveProps(props, config, 'Tooltip')}
      style={{ display: isVisible ? 'inline-flex' : 'none' }}
    >
      <p className="mdn-Text mdn-Text--body mdn-Text--inverse">{children}</p>
    </div>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node,
  isVisible: PropTypes.bool,
  iconSrc: PropTypes.string,
  text: PropTypes.string,
  vertical: PropTypes.bool,
  top: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  bottom: PropTypes.bool
}
